import { IViewBase } from './IViewInfo';
import { IRecommendationItem } from './resourceInfoParts';

// Client side interface for viz recommendation
export type IVizRecommendationInfo = IViewBase & IRecommendationItem;

export const PopularExplanation = 'popular';
export const SimiliarUsersExplanation =  'similar_users';
